// extracted by mini-css-extract-plugin
export default {"msgM":"e9d3be31e4"};